import { MdOutlineProductionQuantityLimits } from 'react-icons/md'
import { Space } from '@arco-design/web-react'
import { PiStarThin } from 'react-icons/pi'
import { FaShop } from 'react-icons/fa6'
import { BsShop } from 'react-icons/bs'
import { CiVideoOn } from 'react-icons/ci'
import { RiLiveLine } from 'react-icons/ri'
import { FaTools } from 'react-icons/fa'
import { MdOutlineSlowMotionVideo } from 'react-icons/md'
import useLocale from '@/utils/useLocale'
import useLang from '@/utils/useLang'
export const useData = () => {
  const t = useLocale()
  const lang = useLang()
  const isChina = lang === 'zh-CN'
  return [
    {
      title: (
        <Space>
          <MdOutlineProductionQuantityLimits />
          <span>{t['product_module']}</span>
        </Space>
      ),
      children: [
        {
          title: t['library.products'],
          path: 'products'
        },
        {
          title: t['leaderboard.products.rank'],
          path: 'product-rank'
        }
      ]
    },
    {
      title: (
        <Space>
          <PiStarThin />
          <span>{t['influencer_module']}</span>
        </Space>
      ),
      children: [
        {
          title: t['menu.influencer.library'],
          path: 'influencers'
        },
        {
          title: t['leaderboard.influencers.rank'],
          path: 'influencer-rank'
        }
      ]
    },
    {
      title: (
        <Space>
          <BsShop />
          <span>{t['shop_module']}</span>
        </Space>
      ),
      children: [
        {
          title: t['shops.name'],
          path: 'shops'
        },
        {
          title: t['leaderboard.shops.rank'],
          path: 'shop-rank'
        },
        {
          title: t['detail.shops'],
          path: 'shop-detail'
        }
      ]
    },
    {
      title: (
        <Space>
          <MdOutlineSlowMotionVideo />
          <span>{t['video_module']}</span>
        </Space>
      ),
      children: [
        {
          title: t['video.name'],
          path: 'videos'
        },
        {
          title: t['videos.leaderboard.top_videos'],
          path: 'top-videos'
        }
      ]
    },
    {
      title: (
        <Space>
          <RiLiveLine />
          <span>{t['live_module']}</span>
        </Space>
      ),
      children: [
        {
          title: t['live.name'],
          path: 'lives'
        },
        {
          title: t['leaderboard.lives.rank'],
          path: 'live-rank'
        }
      ]
    },
    {
      title: (
        <Space>
          <FaTools />
          <span>{t['tool_module']}</span>
        </Space>
      ),
      children: [
        {
          title: t['tools.ai'],
          path: 'ai-tools'
        },
        {
          title: t['tool.calculator.name'],
          path: 'fee-calculator'
        },
        {
          title: t['monitor_tool'],
          path: 'monitor'
        },
        {
          title: t['board.platform.analysis'],
          path: 'browser-extension'
        }
      ]
    }
  ]
}

export const useDetailData = () => {
  const t = useLocale()
  const lang = useLang()
  const isChina = lang === 'zh-CN'
  return [
    {
      path: 'products',
      title: t['product.name'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/products.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/products_en.mp4',
      description: t['guide.product.desc'],
      link: '/products'
    },
    {
      path: 'product-rank',
      title: t['guide.product_rank.title'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/product-rank.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/product-rank_en.mp4',
      description: t['guide.product_rank.desc'],
      link: '/products/leaderboard/top-sold'
    },
    {
      path: 'country-market',
      title: t['dashboard_data'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/dashboard.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/dashboard_en.mp4',
      description: t['guide.dashboard.desc'],
      link: '/analysis/country'
    },
    {
      path: 'fee-calculator',
      title: t['guide.ai_calculate.title'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/calculator.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/calculator_en.mp4',
      description: t['guide.fee-calculator.desc'],
      link: '/tool/calculator'
    },
    {
      path: 'monitor',
      title: t['monitor_tool'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/monitor.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/monitor_en.mp4',
      description: t['monitor.live_video'],
      link: '/live/monitor'
    },
    {
      path: 'ai-tools',
      title: t['tools.ai'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/ai.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/ai_en.mp4',
      description: t['guide.tools_ai.desc'],
      link: '/tool/ai'
    },
    {
      path: 'top-videos',
      title: t['videos.leaderboard.top_videos'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/videos-rank.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/videos-rank_en.mp4',
      description: t['guide.top_video.desc'],
      link: '/videos/leaderboard/top-videos'
    },
    {
      path: 'videos',
      title: t['video.name'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/videos.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/videos_en.mp4',
      description: t['guide.videos.desc'],
      link: '/videos'
    },
    {
      path: 'shop-detail',
      title: t['guide.shop.title'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/shop-detail.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/shop-detail_en.mp4',
      description: t['guide.shop.desc']
    },
    {
      path: 'influencer-rank',
      title: t['leaderboard.influencers'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/influencer-rank.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/influencer-rank_en.mp4',
      description: t['guide.influncer_rank.desc'],
      link: '/leaderboard/sales-champion'
    },
    {
      path: 'live-rank',
      title: t['leaderboard.lives'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/live-rank.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/live-rank_en.mp4',
      description: t['guide.live_rank.desc'],
      link: '/leaderboard/most-viewed'
    },
    {
      path: 'lives',
      title: t['live.name'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/lives.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/lives_en.mp4',
      description: t['guide.lives.desc'],
      link: '/live'
    },
    {
      path: 'influencers',
      title: t['menu.influencer.library'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/influencers.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/influencers_en.mp4',
      description: t['guide.influencers.desc'],
      link: '/influencers'
    },
    {
      path: 'shops',
      title: t['shops.name'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/shops.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/shops_en.mp4',
      description: t['guide.shops.desc'],
      link: '/shops'
    },
    {
      path: 'shop-rank',
      title: t['leaderboard.shops'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/shops-rank.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/shops-rank_en.mp4',
      description: t['guide.shop_rank.desc'],
      link: '/shops/leaderboard/local'
    },
    {
      path: 'browser-extension',
      title: t['board.platform.analysis'],
      video: isChina
        ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/brower-extention.mp4'
        : 'https://echosell-static.tos-cn-beijing.volces.com/guides/brower_plugion.mp4',
      description: t['guide.browser.desc'],
      link: 'https://echotik.live/zh/features/extension'
    }
  ]
}
